/**
 * SEO Configuration
 * Centralized constants for SEO meta tags, Open Graph, and Twitter Cards
 */

export const SEO_CONFIG = {
  siteName: 'Cook with Otto',
  siteUrl: 'https://cookwithotto.otti-tech.de',
  defaultTitle: 'Cook with Otto - AI Cooking Assistant & Recipe App',
  defaultDescription:
    'Smart AI cooking assistant for easy meal planning and personalized recipes. Get step-by-step cooking guidance, organize your recipes, and learn to cook with confidence. Free recipe management app.',
  defaultImage: '/og-image.png', // You'll need to add this image to public folder
  twitterHandle: '@cookwithotto', // Update if you have a Twitter account
  locale: 'en_US',
  type: 'website',
  // Primary keywords for SEO
  keywords: [
    'AI cooking assistant',
    'recipe app',
    'meal planning',
    'cooking guide',
    'AI recipes',
    'recipe management',
    'cooking assistant',
    'smart cooking',
    'personalized recipes',
    'step-by-step cooking',
  ],
};

/**
 * Generate page title with site name suffix
 */
export const getPageTitle = (title?: string): string => {
  if (!title) {
    return SEO_CONFIG.defaultTitle;
  }
  return `${title} | ${SEO_CONFIG.siteName}`;
};

/**
 * Get full URL for a path
 */
export const getFullUrl = (path: string): string => {
  // Remove leading slash if present to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  return `${SEO_CONFIG.siteUrl}/${cleanPath}`;
};
